import type {ReactElement} from 'react';
import {FieldToggleListControl} from '@FormMakerReact/layout/form-maker-right-panel/controls/field-toggle-list-control/field-toggle-list-control';
import {SignupOnly} from '@FormMakerReact/layout/form-maker-right-panel/components/signup-only/signup-only';
import type {FormBackgroundFieldToggleListControlProps} from './form-background-field-toggle-list-control.types';

export function FormBackgroundFieldToggleListControl({component, hideSectionHeading}: FormBackgroundFieldToggleListControlProps): ReactElement | null {
  return (
    <SignupOnly component={component}>
      <FieldToggleListControl component={component} hideSectionHeading={hideSectionHeading} />
    </SignupOnly>
  );
}
